import { render, staticRenderFns } from "./productModal.vue?vue&type=template&id=832ccdb0"
import script from "./productModal.vue?vue&type=script&lang=js"
export * from "./productModal.vue?vue&type=script&lang=js"
import style0 from "./productModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports